const { recordRoboGBIEvent, PAGE_PRODUCT, RELIABLE } = require('utilities/uTagging');

const UtagHelper = {
    getJointHolderInfoFromUserProfile(userProfile) {
        let jointHolderInfo = {};
        jointHolderInfo.isJointHolderAccount = 'no';
        jointHolderInfo.typeHolder = 'primer titular';
        jointHolderInfo.typeUserHolder = '';
        if (userProfile.isJointHolderAccount) {
            jointHolderInfo.isJointHolderAccount = 'si';
            if (userProfile.jointHolderType) {
                jointHolderInfo.typeHolder =
                    userProfile.jointHolderType === 'titular' ? 'primer titular' : userProfile.jointHolderType;
                if (userProfile.jointHolderType !== 'titular') {
                    jointHolderInfo.isJointHolderAccount = '';
                    jointHolderInfo.typeUserHolder = userProfile.isJointHolderNoClient ? 'no cliente' : 'cliente';
                }
            }
        }

        return jointHolderInfo;
    },

    getJointHolderInfoFromInvite(invite, isAlreadyClient = '') {
        let jointHolderInfo = {};
        jointHolderInfo.isJointHolderAccount = '';
        jointHolderInfo.typeHolder = invite.jointHolderType;
        jointHolderInfo.typeUserHolder = isAlreadyClient;

        return jointHolderInfo;
    },

    recordEventRoboGBI(pathForTag = '', eventCategory = '', eventAction = '', eventDetail = '', userProfile) {
        const { recordId, userId, identityMethod, investmentType } = userProfile;
        recordRoboGBIEvent(
            pathForTag,
            PAGE_PRODUCT,
            eventCategory,
            eventAction,
            eventDetail,
            recordId,
            userId,
            RELIABLE[identityMethod],
            investmentType ? investmentType : ''
        );
    },
};

module.exports = UtagHelper;
